
const GET_PROJECT_TYPE = function (state, projectTypeList) {
  state.projectTypeList = projectTypeList;
};

export default {
  GET_PROJECT_TYPE
};
